/**
 * Sidebar API - fetches user and company data.
 * Base URL: set VITE_API_BASE_URL in .env
 * Endpoint: GET /chat/api/sidebar
 * Uses global auth: Bearer token from auth.js
 */

import { getAuthHeaders } from './auth';
import { getBaseUrl } from './utils';
/**
 * Parse API response: expects { status: "success", data: {...} }
 * @param {Response} res
 * @returns {Promise<object>}
 */
async function parseJson(res) {
  const data = await res.json();
  if (!res.ok) {
    const message = data?.message || data?.error || res.statusText || 'Request failed';
    throw new Error(message);
  }
  // Backend returns { status: "success", data: {...} }
  if (data.status === 'success' && data.data) {
    return data.data;
  }
  // Fallback: return data directly if structure is different
  return data.data != null ? data.data : data;
}

/**
 * Fetch sidebar data (user and company info).
 * GET /chat/api/sidebar
 * @returns {Promise<{
 *   company_name: string;
 *   company_logo: string | null;
 *   plan_name: string;
 *   plan_from: string;
 *   plan_to: string;
 *   usage_used: number;
 *   usage_total: number;
 *   files_count: number;
 *   user_name: string;
 *   user_logo: string | null;
 *   user_email: string;
 * }>}
 */
export async function getSidebarData() {
  const base = getBaseUrl();
  const url = `${base}/bot/api/sidebar`.replace(/([^:]\/)\/+/g, '$1');
  const res = await fetch(`${url}?_t=${Date.now()}`, {
    method: 'GET',
    headers: { Accept: 'application/json', ...getAuthHeaders() },
  });
  return parseJson(res);
}
